import { WORLD } from "../config";
import { fbm2, ridged2 } from "../noise";

export function terrainHeight(x: number, z: number, seed = WORLD.seed): number {
  const broad = (fbm2(x * 0.014, z * 0.014, 4, seed) - 0.5) * WORLD.relief * 2.4;
  const rolls = (fbm2(x * 0.055, z * 0.055, 3, seed + 311) - 0.5) * WORLD.relief * 0.7;
  const grain = (fbm2(x * 0.22, z * 0.22, 2, seed + 907) - 0.5) * WORLD.relief * 0.1;
  const ridge = (ridged2(x * 0.03, z * 0.03, 2, seed + 53) - 0.5) * WORLD.relief * 0.5;
  return broad + rolls + grain + ridge;
}

export function terrainNormal(x: number, z: number, epsilon = 0.35): [number, number, number] {
  const dx = terrainHeight(x + epsilon, z) - terrainHeight(x - epsilon, z);
  const dz = terrainHeight(x, z + epsilon) - terrainHeight(x, z - epsilon);
  const nx = -dx;
  const ny = epsilon * 2;
  const nz = -dz;
  const length = Math.hypot(nx, ny, nz) || 1;
  return [nx / length, ny / length, nz / length];
}
